'use strict';

export default function (array, start, end) {
    if (array instanceof Array) {
        return _.slice(array, start ? start : 0, end)
    } else {
        return array;
    }

}


// WEBPACK FOOTER //
// ./src/common/filters/limit-to.js